import React from "react";

type ToolbarTooltipButtonProps = {
  label: string;
  tooltip: string;
  className?: string;
};

const ToolbarTooltipButton: React.FC<ToolbarTooltipButtonProps> = ({
  label,
  tooltip,
  className = "answer-chip",
}) => {
  return (
    <button type="button" className={className} title={tooltip}>
      {label}
    </button>
  );
};

export default ToolbarTooltipButton;
